import * as $ from 'jquery';
import { eID } from '../../services/dom';

export default function activateFlightInfoButton(): void {
    let visible = false;

    const btn = eID('flight-info-btn');
    const { classList } = eID('flight-info-content');

    document.addEventListener('click', event => {
        const isBtn = $(event.target!).closest(btn).length;

        if (isBtn && !visible) classList.add('showing');
        else classList.remove('showing');

        visible = !visible;
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/flight-info-btn.ts